<template>
    <div class="cielo-input">
        <div
            class="cielo-input-container"
            :class="[customClass, { active: !handleOnFocus, editing: editing, error: error, borderless: borderless, dropdownisopen: dropdownIsOpen }]"
        >
            <label v-if="value || !placeholder">{{ label }}</label>
            <the-mask
                v-if="mask"
                class="form-control"
                autocomplete="on"
                :max-length="maxlength"
                :type="type"
                :value="value"
                :name="name"
                @focus="handleOnFocus"
                @blur="handleOnBlur"
                :mask="mask"
                :placeholder="placeholder"
                :disabled="disabled"
                @input="$emit('input', $event)"
                :aria-label="label"
                :aria-invalid="error ? true : false"
                :aria-describedby="'error-'+name"
            />
            <input
                v-else
                class="form-control"
                autocomplete="on"
                :maxLength="maxlength"
                :type="type"
                :value="value"
                :name="name"
                @focus="handleOnFocus"
                @blur="handleOnBlur"
                :placeholder="placeholder"
                :disabled="disabled"
                @input="$emit('input', $event.target.value)"
                @change="$emit('change', $event.target.value)"
                :aria-label="label"
                :aria-invalid="error ? true : false"
                :aria-describedby="'error-'+name"
            />
        </div>
        <small v-if="error" :id="'error-'+name" class="error-description" tabindex="0">{{ error }}</small>
    </div>
</template>

<script>
export default {
  mounted: function () {
    if (this.autofocus)
      this.$el.querySelector('input').focus();
  },

  props: {
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: Infinity
    },
    error: {
      type: String,
      default: null
    },
    mask: {
      type: [Array, String],
      default: null
    },
    borderless: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dropdownIsOpen: {
      type: Boolean
    },
	customClass: {
	  type: String,
	  default: '',
	}
  },

  data() {
    return {
      placeholder: this.label,
      editing: false
    };
  },

  watch: {
    label(value) {
      this.placeholder = value;
    }
  },

  methods: {
    handleOnFocus() {
      if (!this.value)
        this.placeholder = null;

      this.editing = true;
    },

    handleOnBlur() {
      if (!this.value)
        this.placeholder = this.label;

      this.editing = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.cielo-input {
  margin-bottom: 20px;
}

.cielo-input-container {
  position: relative;
  height: 50px;
  border-radius: 8px;
  color: #231F20;
  border: 1px solid #C5CED7;
  background: #FFFFFF;

	&__phone {
		// max-width: 468px; TODO - descomentar quando ajustar o portador Estrangeiro e for para produção definitivo
		width: 100%;
		height: 50px;
		right: 1px;
		position: absolute;
		// border-top-left-radius: 0; TODO - descomentar quando ajustar o portador Estrangeiro e for para produção definitivo
    	// border-bottom-left-radius: 0; TODO - descomentar quando ajustar o portador Estrangeiro e for para produção definitivo

		@media screen and (max-width: 1024px) {
			right: 0;
			top: 0;
			position: relative;
		}
	}

  label,
  input {
    padding: 8px;
  }

  label {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 10px;
    color: #231F20;
    background: none;
    display: block;
    width: 100%;
    line-height: 10px;
    transition: all .3s ease-in-out;
  }

  input {
    border: none;
    background: none;
    width: 100%;
    height: 100%;
    color: #231F20;
    font-size: 16px;
    border-radius: 8px;

	font-weight: 500;

    &:disabled {
      cursor: not-allowed;
      background-color: #F7F7F7;
      border-radius: 8px;
    }

    &::-webkit-input-placeholder,
    &::-ms-input-placeholder,
    &::-ms-input-placeholder,
    &::-moz-placeholder,
    &::placeholder {
      color: #6D7783;
    }

    &:not(:placeholder-shown) {
      padding-top: 20px;
      padding-bottom: 2px;
    }
  }

  &.active {
    border-color: #017CEB !important;

    label {
      color: #017CEB !important;
    }

    input {
      color: #231F20;
    }
  }

  &.editing {
    border-color: #017CEB !important;

    label {
      color: #017CEB !important;
    }

    input {
      color: #231F20 !important;
    }
  }

  &.borderless {
    border-radius: 0;
    border-width: 0px 0px 1px;
  }

  &.dropdownisopen {
    border-bottom-right-radius: 0;
    border-color: #0774E7;
  }
}

//Errors
.error-description {
  color: #DC392A;
  font-size: 12px;
  font-weight: 500;
  padding-left: 8px;
}

.error,
.active.error {
  border-color: #DA3E14 !important;
}

.error label,
.error input,
.active.error label,
.active.error input {
  color: #DA3E14 !important;
}

//bloco de css para resolver questões de layout envolvendo o seletor de paises, classe sendo colocada na view de contato
.phone-custom {
  flex: 1 1;

  .cielo-input-container {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    &.error {
      margin-bottom: 30px;
    }
  }

  .error-description {
    position: absolute;
    top: 54px;
    left: 0;
  }

}

//Bloco de css para resolver problema que impactava todos os inputs de telefone sem as questões específicas do estrangeiro
.phone-custom--v2 {
    #error-Phone {
        position: absolute;
        left: 0;
        top: 55px;
    }
}
</style>
